import React from 'react';
import { Router } from 'react-router-dom';
import history from './../services/history';
import CustomRoutes from './../routes';
import { Provider } from 'react-redux';
import getStore from '../state/store';


function App() {
  return (
     <Provider store={getStore()}>
      <Router history={history}>
        <CustomRoutes />
      </Router>
    </Provider>
  );
}
export default App;